import styled from 'styled-components';

const AboutHomeStyle = styled.div`
	--radiusImage: var(--sp3x);
	--distanceImageInfo: var(--sp14x);
	--widthContent: 67vw;
	--imageWidth: 31.25vw;
	--sizeImage: 136.75%;
	--distanceTitleDesc: var(--sp6x);
	--distanceDescButton: var(--sp7x);

	background-color: var(--green1000);
	padding: var(--sectionDistance) 0;
	overflow: hidden;

	.title {
		display: flex;
	}

	.inner-wrapper {
		display: grid;
		grid-template-columns: var(--imageWidth) 1fr;
		gap: var(--distanceImageInfo);
		max-width: var(--widthContent);
		margin: auto;
		/* overflow: hidden; */

		.image-outside-wrap {
			width: var(--imageWidth);
			opacity: 0;
			transform: translateY(20%);

			.image-cont {
				--proportion: var(--sizeImage);
				width: 100%;
				height: fit-content;
				border-radius: var(--radiusImage);
				overflow: hidden;
			}
		}
	}

	.info-wrap {
		display: flex;
		flex-direction: column;
		justify-content: center;

		.description {
			margin-top: var(--distanceTitleDesc);
			margin-bottom: var(--distanceDescButton);
		}
	}

	.wrap-button {
		width: fit-content;
		height: fit-content;
		transform: scale(0);
	}
	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--radiusImage: var(--sp3x);
		--distanceImageInfo: var(--sp12x);
		--distanceTitleDesc: var(--sp4x);
		--distanceDescButton: var(--sp5x);
		--widthContent: 66.7vw;
		--imageWidth: 30.84vw;
		--sizeImage: 136.75%;
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--radiusImage: var(--sp2-5x);
		--distanceImageInfo: var(--sp8x);
		--distanceTitleDesc: var(--sp3x);
		--distanceDescButton: var(--sp4x);
		--widthContent: 65.3vw;
		--imageWidth: 30.5vw;
		--sizeImage: 144%;
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--radiusImage: var(--sp2x);
		--distanceImageInfo: var(--sp7x);
		--distanceTitleDesc: var(--sp3x);
		--distanceDescButton: var(--sp4x);
		--widthContent: 65.3vw;
		--imageWidth: 30.7vw;
		--sizeImage: 144%;
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--radiusImage: var(--sp1-5x);
		--distanceImageInfo: var(--sp6x);
		--distanceTitleDesc: var(--sp3x);
		--distanceDescButton: var(--sp4x);
		--widthContent: 62.7vw;
		--imageWidth: 30.54vw;
		--sizeImage: 144%;
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--radiusImage: var(--sp1x);
		--distanceImageInfo: var(--sp5x);
		--distanceTitleDesc: var(--sp2x);
		--distanceDescButton: var(--sp3x);
		--widthContent: 64vw;
		--imageWidth: 29.9vw;
		--sizeImage: 144%;
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--radiusImage: var(--sp1x);
		--distanceImageInfo: var(--sp5x);
		--distanceTitleDesc: var(--sp2x);
		--distanceDescButton: var(--sp3x);
		--widthContent: 80.8vw;
		--imageWidth: 38vw;
		--sizeImage: 144%;
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--radiusImage: var(--sp1x);
		--distanceImageInfo: var(--sp4x);
		--distanceTitleDesc: var(--sp2x);
		--distanceDescButton: var(--sp3x);
		--widthContent: 100%;
		--imageWidth: 100%;
		--sizeImage: 150%;

		.inner-wrapper {
			padding: 0 var(--sp2x);
			display: flex;
			flex-direction: column;
		}
	}
`;
export default AboutHomeStyle;
